import { v4 as uuidv4 } from 'uuid';
import { PHOTO_CONTEXTS } from '@/shared/capture/capture-session';
import type { PhotoSlotDefinition } from '@/shared/capture/inventorization-photo-slots';
import { createQueuedOcrJob, OCR_CANDIDATE_FIELDS, type OcrCandidateField } from '@/shared/ocr/ocr-candidates';

export function createOcrJobForPhotoSlot(input: {
  createdAt: string;
  photoId: string;
  sessionId: string;
  slot: PhotoSlotDefinition;
}) {
  const { createdAt, photoId, sessionId, slot } = input;
  const requestedFields = getOcrFieldsForPhotoSlot(slot);

  if (requestedFields.length === 0) {
    return null;
  }

  return createQueuedOcrJob({
    createdAt,
    id: `ocr-${uuidv4()}`,
    photoId,
    requestedFields,
    sessionId,
  });
}

export function getOcrFieldsForPhotoSlot(slot: PhotoSlotDefinition): OcrCandidateField[] {
  if (slot.context === PHOTO_CONTEXTS.detail) {
    return [
      OCR_CANDIDATE_FIELDS.serial,
      OCR_CANDIDATE_FIELDS.manufacturer,
      OCR_CANDIDATE_FIELDS.meterModel,
      OCR_CANDIDATE_FIELDS.apiKey,
    ];
  }

  if (slot.context === PHOTO_CONTEXTS.register) {
    return [
      OCR_CANDIDATE_FIELDS.registerCounter,
      OCR_CANDIDATE_FIELDS.registerUnit,
      OCR_CANDIDATE_FIELDS.registerObis,
      OCR_CANDIDATE_FIELDS.serial,
    ];
  }

  if (slot.context === PHOTO_CONTEXTS.context) {
    return [
      OCR_CANDIDATE_FIELDS.serial,
      OCR_CANDIDATE_FIELDS.manufacturer,
      OCR_CANDIDATE_FIELDS.meterModel,
      OCR_CANDIDATE_FIELDS.registerCounter,
    ];
  }

  return [];
}
